import { login, logout, getInfo } from '@/api/auth'
import { Message } from 'element-ui'

// 从 localStorage 恢复用户状态
const getDefaultState = () => {
  return {
    userId: null,
    username: '',
    role: '',
    isLoggedIn: false
  }
}

const state = {
  userId: parseInt(localStorage.getItem('userId')) || null,
  username: localStorage.getItem('username') || '',
  role: localStorage.getItem('role') || '',
  isLoggedIn: localStorage.getItem('isLoggedIn') === 'true'
}

const mutations = {
  SET_USER_ID: (state, userId) => {
    state.userId = userId
    if (userId) {
      localStorage.setItem('userId', userId)
    } else {
      localStorage.removeItem('userId')
    }
  },
  SET_USERNAME: (state, username) => {
    state.username = username
    if (username) {
      localStorage.setItem('username', username)
    } else {
      localStorage.removeItem('username')
    }
  },
  SET_ROLE: (state, role) => {
    state.role = role
    if (role) {
      localStorage.setItem('role', role)
    } else {
      localStorage.removeItem('role')
    }
  },
  SET_LOGGED_IN: (state, isLoggedIn) => {
    state.isLoggedIn = isLoggedIn
    localStorage.setItem('isLoggedIn', isLoggedIn)
  }
}

const getters = {
  username: state => state.username,
  role: state => state.role,
  isLoggedIn: state => state.isLoggedIn
}

const actions = {
  login({ commit }, userInfo) {
    const { username, password } = userInfo
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: password }).then(response => {
        const { data } = response
        commit('SET_USER_ID', data.id)
        commit('SET_USERNAME', data.username)
        commit('SET_ROLE', data.role)
        commit('SET_LOGGED_IN', true)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      getInfo().then(response => {
        const { data } = response
        if (!data) {
          reject('验证失败，请重新登录')
        }
        commit('SET_USER_ID', data.id)
        commit('SET_USERNAME', data.username)
        commit('SET_ROLE', data.role)
        commit('SET_LOGGED_IN', true)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  logout({ commit }) {
    return new Promise((resolve, reject) => {
      logout().then(() => {
        commit('SET_USER_ID', null)
        commit('SET_USERNAME', '')
        commit('SET_ROLE', '')
        commit('SET_LOGGED_IN', false)
        Message.success('退出登录成功')
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_USER_ID', null)
      commit('SET_USERNAME', '')
      commit('SET_ROLE', '')
      commit('SET_LOGGED_IN', false)
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
